import React from 'react';
import { values } from 'lodash';

import CmsContentList from 'components/data/CmsContentList.js';
import CmsContentRenderer from 'components/data/CmsContentRenderer.js';

import Toast from "components/Toast.js";
import { useGlobalToastsContext } from 'context/ToastProvider';


const cms = {
	confirmation: 'miscText.alternates-cancel-confirmation',
};

const RevokeAlternateInviteSuccess = ({ email }) => {
	const { removeToast } = useGlobalToastsContext();

	return (
		<CmsContentList list={values(cms)} sharedVariables={{ email }}>{() => (
			<Toast
				onClosed={removeToast}
				type="success"
				title={<CmsContentRenderer.Span
					contentKey={cms.confirmation}
					fallbackValue={`You have uninvited ${email} from managing your account.`}
				/>}
			/>
		)}</CmsContentList>
	);
};

export default RevokeAlternateInviteSuccess;
